import { NgModule } from '@angular/core';
import { TimetablePageRoutingModule } from './timetable-routing.module';

import { TimetablePage } from './timetable.page';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    SharedModule,
    TimetablePageRoutingModule
  ],
  declarations: [
    TimetablePage,
  ]
})
export class TimetablePageModule {}
